import { ajax } from "jquery";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { QuoteInvoiceFormInterface } from "../abstracts/mixins/QuoteInvoiceFormInterface";
import { ApproveQuoteForm } from "../../customer-cab/ApproveQuoteForm";

export class Quote extends CRUDEntity {

    constructor(id=null) {
        super();
        this.entityClass = 'quote';
        this.urlRoot = '/jobs-flow/quote';
        this.sectionRootUrl = '/jobs-flow';
        this.id = id;

        Object.assign(Quote.prototype, FormActions);
        Object.assign(Quote.prototype, EntityModalForm);
        Object.assign(Quote.prototype, HasStatus);
        Object.assign(Quote.prototype, QuoteInvoiceFormInterface);
    }

    static statusList = {
        'waiting-approval': 1,
        'approved': 2,
        'changes-requested': 3,
        'rejected': 4,
        'expired': 5,
        'canceled': 6,
        'draft': 11,
    }

    accept(signature=null) {
        const acceptUrl = window.location.href;

        fetch(acceptUrl, {
            method: 'POST',
            body: JSON.stringify({ signature }),
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            if (response.ok) return response.json()
        }).then(response => response.status);
    }

    convertToInvoice() {
        ajax({
            url: `${this.urlRoot}/${this.id}/convert-to-invoice`,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            async: false
        });
    }

    saveAsDraft(successCallback=()=>{}, errorCallback=()=>{}) {
        $.ajaxSetup({
            data: { status: 11 }
        });

        this.id ? this.update({success: successCallback, error: errorCallback}) : this.create({success: successCallback, error: errorCallback});
    }

    getStatusList(){
        return {
            'waiting_approval': 1,
            'approved': 2,
            'changes-requested': 3,
            'rejected': 4,
            'expired': 5,
            'canceled': 6,
            'draft': 11,
        };
    }

    initApprove() {
        ApproveQuoteForm.init(this);
    }
}
